export default __webpack_public_path__ + "static/media/pl.7bb91391.svg";